import { useContext, useEffect, useState } from "react";
import { BankAcquirerDto } from "../../../../dtos/catalogs/bankacquirer/BankAcquirerDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import BankAcquirerDetailSkeleton from "./BankAcquirerDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import BankAcquirerDetailMain from "./BankAcquirerDetailMain";

interface IProps {
  model: BankAcquirerDto | null;
  modelUpdatedEvent: (newModel: BankAcquirerDto) => void;
}

interface BankAcquirerModel {
  id: string;
  name: string;
  companyId?: string;
  bankAccountId?: string;
  terminalNumber: string;
  acquirer: string;
}

export const BankAcquirerDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<BankAcquirerModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("companyId", model.companyId);
      setValue("bankAccountId", model.bankAccountId);
      setValue("terminalNumber", model.terminalNumber);
      setValue("acquirer", model.acquirer);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: BankAcquirerModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    if (action === "save") {
      const newModel: BankAcquirerDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <BankAcquirerDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Settings"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <BankAcquirerDetailMain />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
